import type { ReactNode } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import Caption from 'LuxKit/Typography/Caption'
import LineFilterAltIcon from 'LuxKit/Icons/line/LineFilterAltIcon'

const SearchBarSlot = styled.div`
  flex: 1;
  min-width: 0;
`

const MapFilterButton = styled(Clickable)`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(2)};
`

const FilterIconWrap = styled.div`
  position: relative;
  display: inline-flex;
`

const FilterCountBadge = styled.span`
  position: absolute;
  top: ${rem(-4)};
  inset-inline-end: ${rem(-6)};
  min-width: ${rem(16)};
  height: ${rem(16)};
  padding: 0 ${rem(4)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.surface.normalContrast};
  color: ${props => props.theme.palette.neutral.surface.normalBackground};
  font-size: ${rem(10)};
  line-height: ${rem(16)};
  text-align: center;
`

interface Props {
  searchBar: ReactNode
  brandLink: ReactNode
  accountEntry: ReactNode
  isMapView: boolean
  filterCount: number
  filterLabel: string
  onToggleFilter: () => void
}

function NavRedesignSearchRow({
  searchBar,
  brandLink,
  accountEntry,
  isMapView,
  filterCount,
  filterLabel,
  onToggleFilter,
}: Props) {
  return (
    <>
      {brandLink}
      <SearchBarSlot>
        {searchBar}
      </SearchBarSlot>
      {accountEntry}
      {isMapView && (
        <MapFilterButton onClick={onToggleFilter} aria-label={filterLabel}>
          <FilterIconWrap>
            <LineFilterAltIcon />
            {filterCount > 0 && <FilterCountBadge>{filterCount}</FilterCountBadge>}
          </FilterIconWrap>
          <Caption variant="small">{filterLabel}</Caption>
        </MapFilterButton>
      )}
    </>
  )
}

export default NavRedesignSearchRow
